import { TaxCategories } from '../../../types/mutual-fund-detail.types'
import { IndicativeTax } from '../mf-l2/IndicativeTax'
import { useBottomSheet } from '../../../state-management/contexts/BottomSheetContext'

export const BottomDescription = ({
  taxCategory,
  fundCategory
}: {
  taxCategory: `${TaxCategories}`
  fundCategory: string
}) => {
  const { openNestedBottomSheet, closeNestedBottomSheet } = useBottomSheet()

  const getFundOrientation = () => {
    if ([TaxCategories.HYBRID_NON_EQUITY, TaxCategories.NON_EQUITY].includes(taxCategory as TaxCategories)) {
      return 'non-equity'
    } else if ([TaxCategories.HYBRID_DEBT, TaxCategories.DEBT].includes(taxCategory as TaxCategories)) {
      return 'debt-oriented'
    }
    return 'equity-oriented'
  }

  if (
    [TaxCategories.HYBRID_EQUITY, TaxCategories.HYBRID_DEBT, TaxCategories.HYBRID_NON_EQUITY].includes(
      taxCategory as TaxCategories
    )
  ) {
    return (
      <div className='text-[#6A6E6E] text-[13px] font-[400] pt-5 pb-8'>
        This fund is <span className='font-[700]'> likely </span> to be taxed as{' '}
        <span className='font-[700]'> {getFundOrientation()} </span> fund, based on its asset allocation during the
        current financial year.{' '}
        <span
          onClick={() =>
            openNestedBottomSheet(
              <IndicativeTax
                onDismiss={() => closeNestedBottomSheet()}
                ScreenName='MF_L2'
                fundCategory={fundCategory}
                fundOrientation={getFundOrientation()}
              />
            )
          }
          className='underline'
        >
          Learn more
        </span>
        <br /> <br /> Above calculation is an estimate. Final values depend on the date your order is processed.
      </div>
    )
  }

  if ([TaxCategories.NON_EQUITY, TaxCategories.DEBT].includes(taxCategory as TaxCategories)) {
    return (
      <div className='text-[#6A6E6E] text-[13px] font-[400] pt-5 pb-8'>
        Above calculation is an estimate. Final values depend on the date your order is processed and your income tax
        slab
      </div>
    )
  }

  return (
    <div className='text-[#6A6E6E] text-[13px] font-[400] pt-5 pb-8'>
      Above calculation is an estimate. Final values depend on the date your order is processed.
    </div>
  )
}
